<template>
  <li
    v-if="member"
    class="p-2">
    <div class="d-flex align-items-center justify-content-between">
      <div class="member__content">
        <p class="member__name mr-3">
          {{ member.name }}
        </p>
      </div>
    </div>
  </li>
</template>

<script>

export default {
  props: {
    member: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';
</style>